export default __webpack_public_path__ + "static/Matrix-db60699140276c835706e649d8956bca.png";